import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en/common.json'
import uk from './locales/uk/common.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      uk: { common: uk }
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'uk'],
    ns: ['common'],
    defaultNS: 'common',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    interpolation: { escapeValue: false },
    debug: process.env.NODE_ENV === 'development'
  })

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
})

export default i18n